import React from 'react';


const universities = {
  C: ["Cork Institute of Technology", "Cavan Institute"],
  D: ["Dublin City University (DCU)", "Dublin Institute of Technology (DIT)"],
  G: ["Galway-Mayo Institute of Technology (GMIT)"],
  L: ["Letterkenny Institute of Technology", "Limerick Institute of Technology", "Limerick University of Technology"],
  M: ["Mary Immaculate College (Limerick)", "Munster Technological University"],
  N: ["National College of Ireland (NCI)", "National University of Ireland Galway (NUI Galway)", "National University of Ireland Maynooth (Maynooth University)"],
  Q: ["Queen's University Belfast (Northern Ireland)"],
  T: ["Technological University Dublin (TU Dublin)", "Trinity College Dublin"],
  U: ["University College Cork (UCC)", "University College Dublin (UCD)", "University of Limerick"],
  W: ["Waterford Institute of Technology", "Western Institute of Technology at Tralee"],
};

const IrelandUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">Ireland Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default IrelandUniversities;
